var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3178_45408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.263 12.0035V22.7815C31.263 24.6195 29.7676 26.1148 27.9296 26.1148H23.0406L17.1253 32.0125C17.1246 32.0131 17.106 32.0318 17.106 32.0318L17.0733 31.9991L14.1516 31.2095L15.2246 30.1451C15.2226 30.1431 21.938 23.4485 21.938 23.4485H27.9293C28.2906 23.4485 28.596 23.1431 28.596 22.7818V12.0035C28.596 11.6421 28.2906 11.3368 27.9293 11.3368H11.6026C11.238 11.3368 10.9296 11.6451 10.9296 12.0098V22.7815C10.9296 23.1428 11.235 23.4481 11.5963 23.4481H13.2483C14.7163 23.4481 15.917 24.6425 15.925 26.1105L15.9346 26.7351C15.9346 26.7365 15.935 26.7628 15.935 26.7628L15.9086 26.7631L13.3076 29.4408L13.2713 26.8028C13.2686 26.8028 13.2586 26.1375 13.2586 26.1375L11.5966 26.1145C9.75863 26.1145 8.2633 24.6191 8.2633 22.7811V12.0098C8.2633 10.1685 9.76163 8.67015 11.603 8.67015H27.93C29.7676 8.67015 31.263 10.1655 31.263 12.0035ZM3.30363 14.8225V4.05048C3.30363 3.68582 3.61163 3.37748 3.97663 3.37748H20.3036C20.665 3.37748 20.9703 3.68282 20.9703 4.04415V6.67015H23.637V4.04415C23.637 2.20615 22.1416 0.710815 20.3036 0.710815H3.97663C2.1353 0.710815 0.636963 2.20915 0.636963 4.05048V14.8221C0.636963 16.6601 2.1323 18.1555 3.9703 18.1555H6.26296V15.4888H3.9703C3.60896 15.4891 3.30363 15.1838 3.30363 14.8225Z",
    fill: "#2D71B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3178_45408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.c281626af87e079a5cdda316df6d58f2.svg";
export { ForwardRef as ReactComponent };